import React from 'react';
import Divider from '../../Divider/Divider';
import { string } from 'prop-types';
import classNames from 'classnames';
var propTypes = {
  /** Add your own custom class names to the component */
  className: string
};
var defaultProps = {};
/** Used to visually separate grouped Dropdown Items within a Dropdown Menu.
 * @visibleName Dropdown Divider
 * */

var DropdownDivider = function DropdownDivider(_ref) {
  var className = _ref.className;
  var componentClassNames = classNames('rds-dropdown__divider', className);
  return /*#__PURE__*/React.createElement(Divider, {
    className: componentClassNames,
    spacing: "none"
  });
};

DropdownDivider.propTypes = propTypes;
DropdownDivider.defaultProps = defaultProps;
export default DropdownDivider;